import api from '../api'

const exam = 'academy/api/Exam'
const skillUpExaminationServices = {
  getExamination(courseSessionField) {
    return api.get(`${exam}/GetOriginal/${courseSessionField}`)
  },
  getExaminationTable(courseSessionField) {
    return api.get(`${exam}/GetPeople/${courseSessionField}`)
  },
  addExam(params) {
    return api.post(`${exam}/Add`, params)
  },

  editExam(params) {
    return api.post(`${exam}/Edit`, params)
  },
  getAnswerAdmin(params) {
    return api.post(`${exam}/GetAnswerAdmin`, params)
  },
}
export default skillUpExaminationServices
